import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import "./LabelDetail.css";

const LabelDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [label, setLabel] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/patients/fsa_labels/${id}/`, {
        headers: { Authorization: `Token ${token}` },
      })
      .then((res) => {
        setLabel(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Error fetching Label detail");
        setLoading(false);
      });
  }, [id, token]);

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this label?")) {
      axios
        .delete(`${process.env.REACT_APP_BACKEND_URL}/patients/fsa_labels/${id}/delete/`, {
          headers: { Authorization: `Token ${token}` },
        })
        .then(() => {
          navigate("/labels");
        })
        .catch((err) => {
          alert("Error deleting label");
        });
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error-message">{error}</p>;
  if (!label) return <p>No Label found.</p>;

  return (
    <div className="study-detail-container">
      <h3>Label Detail</h3>
      <p>
        <strong>ID:</strong> {label.id}
      </p>
      <p>
        <strong>Modality:</strong> 
        <Link style={{ textDecoration: "none" }} to={`/${label.foreign_key.modality}s/`}>
          {label.foreign_key.modality.toUpperCase()}
        </Link>
      </p>
      <p>
        <strong>Foreign Key ID:</strong>
        <Link style={{ textDecoration: "none" }} to={`/${label.foreign_key.modality}s/${label.foreign_key.id}`}>
          {label.foreign_key.id}
        </Link>
      </p>
      <p>
        <strong>File Path:</strong> {label.file_path}
      </p>
      <p>
        <strong>Datasets:</strong> {label.datasets.join(", ")}
      </p>
      <p>
        <strong>Annotator:</strong> {label.annotator}
      </p>
      
      <h4>Frame Information</h4>
      <p>
        <strong>Frame End Systole:</strong> {label.frame_end_systole || 'N/A'}
      </p>
      <p>
        <strong>Frame End Diastole:</strong> {label.frame_end_diastole || 'N/A'}
      </p>
      <p>
        <strong>Frame Random:</strong> {label.frame_random || 'N/A'}
      </p>
      
      <p>
        <strong>Side:</strong> {label.side || 'Unknown'}
      </p>
      
      <h4>Contrast Information</h4>
      <p>
        <strong>Frame Initial Contrast Appearance:</strong> {label.frame_initial_contrast_appearance || 'N/A'}
      </p>
      <p>
        <strong>Frame Start Washout:</strong> {label.frame_start_washout || 'N/A'}
      </p>
      <p>
        <strong>Frame End Washout:</strong> {label.frame_end_washout || 'N/A'}
      </p>
      
      <p>
        <strong>Comments:</strong> {label.comments || 'N/A'}
      </p>
      
      <p>
        <strong>Uploader:</strong> {label.uploader}
      </p>
      <p>
        <strong>Creation Time:</strong>{" "}
        {new Date(label.creation_time).toLocaleString()}
      </p>
      <p>
        <strong>Updated Time:</strong>{" "}
        {new Date(label.updated_time).toLocaleString()}
      </p>
      <div className="patient-detail-actions">
        <Link to={`/labels/${id}/edit`}>
          <button>Edit</button>
        </Link>
        <Link to={`/dicoms/${label.foreign_key.id}`}>
          <button>View DICOMs</button>
        </Link>
        <button onClick={handleDelete}>Delete</button>
      </div>
    </div>
  );
};

export default LabelDetail;
